export default {
      id: "color_charts-usage",
      viewBox: "0 0 146 114",
      url: __webpack_public_path__ + "sprite.svg#color_charts",
      toString: function () {
        return this.url;
      }
    }